import { useRoutes,useNavigate } from "react-router-dom";

import { AuthRoutes, Routes ,MinimalHeaderRoute,FullScreenLayoutRoute } from './allRoutes';
import GetAllowedRoutes from './GetAllowedRoutes'
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserMessages } from "../redux/actions/messageActions";
// import { TelegramSignInAction } from "../redux/actions/authActions";

const AppRoutes = () => {
    const AuthState = useSelector((state) => state.Auth);
	  const dispatch = useDispatch(); 
    const navigate = useNavigate();
    
    useEffect(() => { 
        if(AuthState?.token && !localStorage.getItem('isFromCustomCategory')){
            dispatch(getUserMessages());
        }
    }, [AuthState?.token,dispatch,navigate]);  

    const routes = useRoutes(GetAllowedRoutes([...Routes,...AuthRoutes,...MinimalHeaderRoute,...FullScreenLayoutRoute]));
    return routes;
};

export default AppRoutes;